// import Select from 'react-select';
// import { useEffect, useMemo, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import { Card, CardFooter, CardHeader } from '@components/card/card';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermissionCache';
// import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
// import ReportPagination from '@Helper/ReportPaged/ReportPagination';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

// type ReportRequestDto = {
//   pageIndex?: number;
//   pageSize?: number;
//   sortBy?: string | null;
//   sortDir?: string | null;

//   // Purchase Order filters
//   purchaseId?: string | null;
//   purchaseCodeLike?: string | null;
//   purchaseTypeId?: string | null;
//   purchaseFromDate?: string | null;
//   purchaseToDate?: string | null;

//   // Organization filters
//   organizationId?: string | null;
//   supplierId?: string | null;
//   inventoryId?: string | null;
//   effect?: number | null;

//   // Inventory transaction filters
//   invFromDate?: string | null;
//   invToDate?: string | null;
//   invBranchId?: string | null;
//   invInventoryId?: string | null;
//   invTrxTypeId?: string | null;
//   invTrxTypeIds?: string | null;
//   invCodeLike?: string | null;

//   // Invoice filters
//   supplierInvoiceNumLike?: string | null;
//   invoiceId?: string | null;
//   invoiceNumLike?: string | null;
//   invoiceType?: string | null;
//   invoiceTypes?: string | null;
//   invoiceFromDate?: string | null;
//   invoiceToDate?: string | null;
//   invoicePosted?: boolean | null;
//   invoiceCancelled?: boolean | null;

//   // Payment filters
//   paymentId?: string | null;
//   paymentCodeLike?: string | null;
//   paymentStatus?: string | null;
//   paymentStatuses?: string | null;
//   paymentMethodId?: string | null;
//   bankAccountId?: string | null;
//   paymentFromDate?: string | null;
//   paymentToDate?: string | null;

//   // Additional filters
//   onlyWithInvoices?: boolean | null;
//   onlyWithPayments?: boolean | null;
// };

// type RowDto = {
//   rootId: string;
//   nodeId: string;
//   parentNodeId: string | null;
//   level: number;
//   nodeType: string;
//   sortKey: string;
//   docCode: string;
//   docName: string;
//   docDate: string;
//   organizationId: string;
//   brancH_NAME: string;
//   peoplE_NAME: string;
//   peopleId: string;
//   inventoryId: string;
//   amount: number;
//   vatAmount: number;
//   grossAmount: number;
//   effectSign: number;
//   effectAmount: number;
//   linkSource: string | null;
//   matId: string | null;
//   matCode: string | null;
//   matTypeName: string | null;
//   supplierInvoiceNum: string | null;
//   postedFlag: boolean | null;
//   cancelledFlag: boolean | null;
//   invoiceType: string | null;
//   paymentStatus: string | null;
//   scheduleAmount: number | null;
//   scheduleDueDate: string | null;
//   paidEffectSum: number | null;
//   balanceEffect: number | null;
//   paymentMethodId: string | null;
//   bankAccountId: string | null;
//   appliedAmount: number | null;
//   paymentTotalAmount: number | null;
// };

// const REPORT_KEY = 'RPT_PurchaseFlow';
// const ENDPOINT = 'PurchaseOrder/GetPurFlowPagedQuery';

// const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));
// const n0 = (v: any) => (v === null || v === undefined || Number.isNaN(Number(v)) ? 0 : Number(v));
// const formatNumber = (num: number, digits: number = 2) => {
//   return new Intl.NumberFormat('en-US', {
//     minimumFractionDigits: digits,
//     maximumFractionDigits: digits
//   }).format(num);
// };
// const formatDate = (dateString: string) => {
//   if (!dateString) return '—';
//   const date = new Date(dateString);
//   return new Intl.DateTimeFormat('en-US', {
//     year: 'numeric',
//     month: '2-digit',
//     day: '2-digit'
//   }).format(date);
// };
// const getOptId = (opt: any): string | null => {
//   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
//   return v ? String(v) : null;
// };

// const getNodeTypeBadge = (type: string, isAr: boolean) => {
//   switch (type) {
//     case 'PUR':
//       return <span className='badge bg-theme'>{isAr ? 'أمر شراء' : 'PO'}</span>;
//     case 'APINV':
//       return <span className='badge bg-success'>{isAr ? 'فاتورة' : 'Invoice'}</span>;
//     case 'PAY':
//       return <span className='badge bg-warning'>{isAr ? 'دفعة' : 'Payment'}</span>;
//     case 'INV':
//       return <span className='badge bg-info'>{isAr ? 'حركة' : 'Inventory'}</span>;
//     default:
//       return <span className='badge bg-secondary'>{type}</span>;
//   }
// };

// const getEffectSignIcon = (sign: number) => {
//   if (sign > 0) return <i className='fas fa-arrow-up text-success' title='إيجابي'></i>;
//   if (sign < 0) return <i className='fas fa-arrow-down text-danger' title='سلبي'></i>;
//   return <i className='fas fa-minus text-muted' title='محايد'></i>;
// };

// const RPT_PurchaseFlow = () => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   // options
//   const { OperatingUnitOptions, loading: loadingOperatingUnitOptions } = useGetOperatingUnitWithPermission();
//   const { OptionSuppliers, loading: loadingSupplierOptions } = useGetSuppliersList();

//   // Filters state
//   const [branchFilter, setBranchFilter] = useState<any>(null);
//   const [inventoryFilter, setInventoryFilter] = useState<any>(null);
//   const [supplierFilter, setSupplierFilter] = useState<any>(null);

//   // Date ranges
//   const [purchaseFromDate, setPurchaseFromDate] = useState<Date | null>(null);
//   const [purchaseToDate, setPurchaseToDate] = useState<Date | null>(null);

//   // Code filters
//   const [purchaseCodeLike, setPurchaseCodeLike] = useState<string>('');
//   const [supplierInvoiceNumLike, setSupplierInvoiceNumLike] = useState<string>('');

//   // Checkbox filters
//   const [onlyWithInvoices, setOnlyWithInvoices] = useState<boolean>(false);
//   const [onlyWithPayments, setOnlyWithPayments] = useState<boolean>(false);

//   // Expanded rows state (like in PriceList example)
//   const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

//   // Search term
//   const [searchTerm, setSearchTerm] = useState<string>('');

//   const [showExport, setShowExport] = useState(false);

//   const exportColumns: ExportColumn<RowDto>[] = [
//     {
//       headerAr: 'التاريخ',
//       headerEn: 'Date',
//       value: r => formatDate(r.docDate)
//     },
//     {
//       headerAr: 'الكود',
//       headerEn: 'Code',
//       value: r => r.docCode || ''
//     },
//     {
//       headerAr: 'الوصف',
//       headerEn: 'Description',
//       value: r => r.docName || ''
//     },
//     {
//       headerAr: 'النوع',
//       headerEn: 'Type',
//       value: (r, ctx) => {
//         switch (r.nodeType) {
//           case 'PUR':
//             return ctx.isAr ? 'أمر شراء' : 'Purchase Order';
//           case 'APINV':
//             return ctx.isAr ? 'فاتورة' : 'Invoice';
//           case 'PAY':
//             return ctx.isAr ? 'دفعة' : 'Payment';
//           case 'INV':
//             return ctx.isAr ? 'حركة مخزنية' : 'Inventory';
//           default:
//             return r.nodeType;
//         }
//       }
//     },
//     {
//       headerAr: 'الفرع',
//       headerEn: 'Branch',
//       value: r => r.brancH_NAME || ''
//     },
//     {
//       headerAr: 'المورد',
//       headerEn: 'Supplier',
//       value: r => r.peoplE_NAME || ''
//     },
//     {
//       headerAr: 'المبلغ',
//       headerEn: 'Amount',
//       value: r => r.amount || 0
//     },
//     {
//       headerAr: 'ضريبة',
//       headerEn: 'VAT',
//       value: r => r.vatAmount || 0
//     },
//     {
//       headerAr: 'الصافي',
//       headerEn: 'Gross',
//       value: r => r.grossAmount || 0
//     },
//     {
//       headerAr: 'التأثير',
//       headerEn: 'Effect',
//       value: r => r.effectAmount || 0
//     },
//     {
//       headerAr: 'رقم فاتورة المورد',
//       headerEn: 'Supplier Invoice',
//       value: r => r.supplierInvoiceNum || ''
//     },
//     {
//       headerAr: 'مرحل',
//       headerEn: 'Posted',
//       value: r => (r.postedFlag === true ? 'نعم' : r.postedFlag === false ? 'لا' : '')
//     },
//     {
//       headerAr: 'ملغي',
//       headerEn: 'Cancelled',
//       value: r => (r.cancelledFlag === true ? 'نعم' : r.cancelledFlag === false ? 'لا' : '')
//     },
//     {
//       headerAr: 'حالة الدفعة',
//       headerEn: 'Payment Status',
//       value: (r, ctx) => {
//         if (!r.paymentStatus) return '';
//         switch (r.paymentStatus) {
//           case 'PENDING':
//             return ctx.isAr ? 'معلق' : 'Pending';
//           case 'PAID':
//             return ctx.isAr ? 'مدفوع' : 'Paid';
//           case 'PARTIALLY_PAID':
//             return ctx.isAr ? 'مدفوع جزئياً' : 'Partially Paid';
//           default:
//             return r.paymentStatus;
//         }
//       }
//     }
//   ];

//   // report state
//   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
//   const items = (report?.items ?? []) as RowDto[];
//   const meta = report?.meta ?? null;
//   const loading = report?.loading ?? false;
//   const error = report?.error ?? null;
//   const isAr = i18n.language !== 'en';

//   const activeFiltersCount = useMemo(() => {
//     let c = 0;
//     if (branchFilter) c++;
//     if (inventoryFilter) c++;
//     if (supplierFilter) c++;
//     if (purchaseFromDate) c++;
//     if (purchaseToDate) c++;
//     if (purchaseCodeLike) c++;
//     if (supplierInvoiceNumLike) c++;
//     if (onlyWithInvoices) c++;
//     if (onlyWithPayments) c++;
//     return c;
//   }, [
//     branchFilter,
//     inventoryFilter,
//     supplierFilter,
//     purchaseFromDate,
//     purchaseToDate,
//     supplierInvoiceNumLike,
//     purchaseCodeLike,
//     onlyWithInvoices,
//     onlyWithPayments
//   ]);

//   useEffect(() => {
//     dispatch(
//       initReport({
//         reportKey: REPORT_KEY,
//         endpoint: ENDPOINT,
//         initialRequest: {
//           pageIndex: 0,
//           pageSize: 50
//         }
//       })
//     );
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   }, [dispatch]);

//   const applyFilters = () => {
//     const organizationId = getOptId(branchFilter);
//     const supplierId = getOptId(supplierFilter);

//     const prevReq = ((report as any)?.request ?? {}) as any;

//     const nextReq = {
//       ...prevReq,
//       pageIndex: 0,

//       organizationId: organizationId ?? undefined,
//       supplierId: supplierId ?? undefined,

//       purchaseCodeLike: purchaseCodeLike.trim() || undefined,
//       supplierInvoiceNumLike: supplierInvoiceNumLike.trim() || undefined,
//       purchaseFromDate: purchaseFromDate ? purchaseFromDate.toISOString() : undefined,
//       purchaseToDate: purchaseToDate ? purchaseToDate.toISOString() : undefined
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: nextReq }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   const clearFilters = () => {
//     setBranchFilter(null);
//     setInventoryFilter(null);
//     setSupplierFilter(null);
//     setPurchaseFromDate(null);
//     setPurchaseToDate(null);
//     setPurchaseCodeLike('');
//     setSupplierInvoiceNumLike('');
//     setOnlyWithInvoices(false);
//     setOnlyWithPayments(false);

//     const resetReq: Partial<ReportRequestDto> = {
//       pageIndex: 0,
//       pageSize: 50,

//       purchaseId: undefined,
//       purchaseCodeLike: undefined,
//       purchaseTypeId: undefined,
//       purchaseFromDate: undefined,
//       purchaseToDate: undefined,

//       organizationId: undefined,
//       supplierId: undefined,
//       inventoryId: undefined,
//       effect: undefined,

//       invFromDate: undefined,
//       invToDate: undefined,
//       invBranchId: undefined,
//       invInventoryId: undefined,
//       invTrxTypeId: undefined,
//       invTrxTypeIds: undefined,
//       invCodeLike: undefined,

//       supplierInvoiceNumLike: undefined,
//       invoiceId: undefined,
//       invoiceNumLike: undefined,
//       invoiceType: undefined,
//       invoiceTypes: undefined,
//       invoiceFromDate: undefined,
//       invoiceToDate: undefined,
//       invoicePosted: undefined,
//       invoiceCancelled: undefined,

//       paymentId: undefined,
//       paymentCodeLike: undefined,
//       paymentStatus: undefined,
//       paymentStatuses: undefined,
//       paymentMethodId: undefined,
//       bankAccountId: undefined,
//       paymentFromDate: undefined,
//       paymentToDate: undefined,

//       onlyWithInvoices: undefined,
//       onlyWithPayments: undefined,

//       sortBy: 'docDate',
//       sortDir: 'DESC'
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   // Group items by rootId and build hierarchy
//   const purchaseOrders = useMemo(() => {
//     // Filter by search term if needed
//     let filteredItems = items;
//     if (searchTerm.trim() !== '') {
//       const searchLower = searchTerm.toLowerCase();
//       filteredItems = items.filter(
//         item =>
//           item.docCode?.toLowerCase().includes(searchLower) ||
//           item.peoplE_NAME?.toLowerCase().includes(searchLower) ||
//           item.brancH_NAME?.toLowerCase().includes(searchLower) ||
//           item.supplierInvoiceNum?.toLowerCase().includes(searchLower)
//       );
//     }

//     // Get only root items (PUR) and their children
//     const rootItems = filteredItems.filter(item => item.nodeType === 'PUR');

//     // Sort roots by sortKey
//     return rootItems.sort((a, b) => a.sortKey.localeCompare(b.sortKey));
//   }, [items, searchTerm]);

//   // Get children for a specific node
//   const getChildNodes = (nodeId: string): RowDto[] => {
//     return items.filter(item => item.parentNodeId === nodeId).sort((a, b) => a.sortKey.localeCompare(b.sortKey));
//   };

//   // Toggle row expansion
//   const toggleRow = (rowId: string): void => {
//     const newExpandedRows = new Set(expandedRows);
//     if (newExpandedRows.has(rowId)) {
//       newExpandedRows.delete(rowId);
//     } else {
//       newExpandedRows.add(rowId);
//     }
//     setExpandedRows(newExpandedRows);
//   };

//   // Recursive render function (like in PriceList example)
//   const renderPurchaseRow = (item: RowDto, level: number = 0, isChild: boolean = false): any => {
//     const children = getChildNodes(item.nodeId);
//     const hasChildren = children.length > 0;
//     const isExpanded = expandedRows.has(item.nodeId);
//     const isRoot = item.nodeType === 'PUR';

//     return (
//       <>
//         {/* Main row */}
//         <tr key={item.nodeId} className={isChild ? 'table-active' : ''}>
//           <td className='align-middle'>
//             <div className='d-flex align-items-center'>
//               {/* Indentation */}
//               <div style={{ marginRight: `${level * 25}px` }}></div>

//               {/* Expand/Collapse button */}
//               {hasChildren && (
//                 <button
//                   type='button'
//                   className='btn btn-sm btn-outline-secondary me-2'
//                   onClick={() => toggleRow(item.nodeId)}
//                   style={{ width: '24px', height: '24px', padding: '0' }}
//                 >
//                   <i className={`fas fa-${isExpanded ? 'minus' : 'plus'} fa-xs`}></i>
//                 </button>
//               )}
//               {!hasChildren && <span className='me-2' style={{ width: '24px' }}></span>}

//               {/* Icon based on node type */}
//               <span className='me-2'>
//                 {item.nodeType === 'PUR' && (
//                   <i className={`fas fa-shopping-cart ${isRoot ? 'text-theme' : 'text-muted'}`}></i>
//                 )}
//                 {item.nodeType === 'APINV' && (
//                   <i className={`fas fa-file-invoice ${isChild ? 'text-success' : 'text-muted'}`}></i>
//                 )}
//                 {item.nodeType === 'PAY' && (
//                   <i className={`fas fa-money-bill-wave ${isChild ? 'text-warning' : 'text-muted'}`}></i>
//                 )}
//                 {item.nodeType === 'INV' && <i className={`fas fa-warehouse text-info`}></i>}
//               </span>

//               <div className='d-flex flex-column'>
//                 <div className='d-flex align-items-center gap-2 flex-wrap'>
//                   <strong className={isChild ? 'text-muted' : ''}>{safe(item.docCode)}</strong>
//                   {getNodeTypeBadge(item.nodeType, isAr)}
//                   {item.cancelledFlag === true && (
//                     <span className='badge bg-danger'>
//                       <i className='fas fa-ban me-1'></i>
//                       {isAr ? 'ملغي' : 'Cancelled'}
//                     </span>
//                   )}
//                 </div>
//                 <small className='text-muted'>{safe(item.docName)}</small>

//                 {item.supplierInvoiceNum && (
//                   <small className='text-muted'>
//                     <i className='fas fa-file-invoice me-1'></i>
//                     {isAr ? 'فاتورة المورد' : 'Supplier Inv'}: {item.supplierInvoiceNum}
//                   </small>
//                 )}

//                 {item.linkSource === 'ViaINV' && (
//                   <small className='text-info'>
//                     <i className='fas fa-link me-1'></i>
//                     {isAr ? 'عبر فاتورة' : 'Via Invoice'}
//                   </small>
//                 )}
//               </div>
//             </div>
//           </td>

//           <td className='align-middle'>
//             <div className='fw-medium'>{formatDate(item.docDate)}</div>
//             {item.scheduleDueDate && (
//               <small className='text-muted d-block'>
//                 <i className='fas fa-calendar-check me-1'></i>
//                 {formatDate(item.scheduleDueDate)}
//               </small>
//             )}
//           </td>

//           <td className='align-middle'>
//             <strong className={isChild ? 'text-muted' : ''}>{safe(item.brancH_NAME)}</strong>
//           </td>

//           <td className='align-middle'>
//             <div className='d-flex flex-column'>
//               <strong className={isChild ? 'text-muted' : ''}>{safe(item.peoplE_NAME)}</strong>
//             </div>
//           </td>

//           <td className='text-end align-middle'>
//             <div className='fw-bold'>{formatNumber(item.amount)}</div>
//           </td>

//           <td className='text-center align-middle'>
//             {item.nodeType === 'APINV' && item.balanceEffect !== null && (
//               <div>
//                 <div className={`fw-bold ${item.balanceEffect > 0 ? 'text-danger' : 'text-success'}`}>
//                   {formatNumber(Math.abs(item.balanceEffect))}
//                 </div>
//                 {item.paidEffectSum !== null && (
//                   <small className='text-muted d-block'>
//                     {isAr ? 'مدفوع' : 'Paid'}: {formatNumber(Math.abs(item.paidEffectSum))}
//                   </small>
//                 )}
//               </div>
//             )}
//             {item.nodeType === 'PAY' && (
//               <div>
//                 <div className='fw-bold text-success'>{formatNumber(item.appliedAmount || 0)}</div>
//                 <small className='text-muted d-block'>{item.paymentStatus}</small>
//               </div>
//             )}
//           </td>

//           <td className='text-center align-middle'>
//             <div className='d-flex flex-column align-items-center gap-1'>
//               {item.postedFlag !== null &&
//                 (item.postedFlag ? (
//                   <span className='badge bg-success'>
//                     <i className='fas fa-check-circle me-1'></i>
//                   </span>
//                 ) : (
//                   <span className='badge bg-warning'>
//                     <i className='fas fa-clock me-1'></i>
//                   </span>
//                 ))}
//               {item.paymentStatus === 'Active' && <span className='badge bg-info'>{isAr ? 'نشط' : 'Active'}</span>}
//             </div>
//           </td>
//         </tr>

//         {/* Render children if expanded */}
//         {hasChildren && isExpanded && children.map(child => renderPurchaseRow(child, level + 1, true))}
//       </>
//     );
//   };

//   return (
//     <>
//       {/* Filters Card */}
//       <Card className='mb-4'>
//         <CardHeader>
//           <h6 className='mb-0'>
//             <i className='fas fa-filter me-2'></i>
//             {t('Filters')}
//           </h6>
//         </CardHeader>
//         <div className='card-body'>
//           <div className='row g-2 align-items-center'>
//             <div className='col-lg-3'>
//               <Select
//                 isLoading={loadingOperatingUnitOptions}
//                 value={branchFilter}
//                 onChange={setBranchFilter}
//                 options={OperatingUnitOptions}
//                 placeholder={t('Branch')}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>

//             <div className='col-lg-3'>
//               <Select
//                 isLoading={loadingSupplierOptions}
//                 value={supplierFilter}
//                 onChange={setSupplierFilter}
//                 options={OptionSuppliers}
//                 placeholder={t('Supplier')}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>

//             <div className='col-lg-2'>
//               <input
//                 type='text'
//                 className='form-control'
//                 value={purchaseCodeLike}
//                 onChange={e => setPurchaseCodeLike(e.target.value)}
//                 placeholder={isAr ? 'رقم أمر الشراء' : 'PO Code'}
//               />
//             </div>
//             <div className='col-lg-2'>
//               <input
//                 type='text'
//                 className='form-control'
//                 value={supplierInvoiceNumLike}
//                 onChange={e => setSupplierInvoiceNumLike(e.target.value)}
//                 placeholder={'رقم فاتورة المورد'}
//               />
//             </div>

//             <div className='col-lg-2'>
//               <DatePicker
//                 selected={purchaseFromDate}
//                 onChange={setPurchaseFromDate}
//                 placeholderText={isAr ? 'من تاريخ' : 'From Date'}
//                 className='form-control'
//                 dateFormat='yyyy-MM-dd'
//                 isClearable
//               />
//             </div>

//             <div className='col-lg-2'>
//               <DatePicker
//                 selected={purchaseToDate}
//                 onChange={setPurchaseToDate}
//                 placeholderText={isAr ? 'إلى تاريخ' : 'To Date'}
//                 className='form-control'
//                 dateFormat='yyyy-MM-dd'
//                 isClearable
//                 minDate={purchaseFromDate || undefined}
//               />
//             </div>
//           </div>

//           <div className='row mt-3'>
//             <div className='col-auto'>
//               <div className='form-check form-check-inline'>
//                 <input
//                   className='form-check-input'
//                   type='checkbox'
//                   id='onlyWithInvoices'
//                   checked={onlyWithInvoices}
//                   onChange={e => setOnlyWithInvoices(e.target.checked)}
//                 />
//                 <label className='form-check-label' htmlFor='onlyWithInvoices'>
//                   {isAr ? 'فقط مع فواتير' : 'Only with Invoices'}
//                 </label>
//               </div>
//               <div className='form-check form-check-inline'>
//                 <input
//                   className='form-check-input'
//                   type='checkbox'
//                   id='onlyWithPayments'
//                   checked={onlyWithPayments}
//                   onChange={e => setOnlyWithPayments(e.target.checked)}
//                 />
//                 <label className='form-check-label' htmlFor='onlyWithPayments'>
//                   {isAr ? 'فقط مع دفعات' : 'Only with Payments'}
//                 </label>
//               </div>
//             </div>

//             <div className='col-auto ms-auto'>
//               <button
//                 className='btn btn-outline-secondary me-2'
//                 type='button'
//                 onClick={clearFilters}
//                 disabled={activeFiltersCount === 0}
//               >
//                 <i className='fas fa-times fa-fw me-1'></i>
//                 {t('Clear')}
//               </button>
//               <button
//                 className='btn btn-theme'
//                 type='button'
//                 onClick={applyFilters}
//                 disabled={activeFiltersCount === 0}
//               >
//                 <i className='fas fa-filter fa-fw me-1'></i>
//                 {t('Apply')}
//               </button>
//             </div>
//           </div>
//         </div>
//       </Card>

//       {/* Main Table Card */}
//       <Card className='mb-4'>
//         <Loading loading={loading} error={error}>
//           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 500px)', overflowY: 'auto' }}>
//             <table className='table table-hover mb-0'>
//               <thead
//                 className='table-actived fw-bold sticky-top bg-theme bg-opacity-25'
//                 style={{ top: 0, zIndex: 10, backdropFilter: 'blur(20px)' }}
//               >
//                 <tr>
//                   <th className='small'>{isAr ? 'المستند' : 'Document'}</th>
//                   <th className='small'>{isAr ? 'التاريخ' : 'Date'}</th>
//                   <th className='small'>{isAr ? 'الفرع' : 'Branch'}</th>
//                   <th className='small'>{isAr ? 'المورد' : 'Supplier'}</th>
//                   <th className='small text-end'>{isAr ? 'المبلغ' : 'Amount'}</th>

//                   <th className='small text-center'>{isAr ? 'الرصيد' : 'Balance'}</th>
//                   <th className='small text-center'>{isAr ? 'الحالة' : 'Status'}</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {!loading && purchaseOrders.length > 0 ? (
//                   purchaseOrders.map(item => renderPurchaseRow(item))
//                 ) : !loading ? (
//                   <tr>
//                     <td colSpan={9} className='text-center py-5'>
//                       <div className='text-muted'>
//                         <i className='fas fa-shopping-cart fa-3x mb-3 opacity-50'></i>
//                         <h6>{t('NoData')}</h6>
//                         <small>{searchTerm ? 'لا توجد نتائج للبحث' : t('TryChangingFilters')}</small>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : null}
//               </tbody>
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
//             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
//           </div>
//         </CardFooter>
//       </Card>

//       <ReportExportExcelModal
//         show={showExport}
//         onHide={() => setShowExport(false)}
//         reportKey={REPORT_KEY}
//         endpoint={ENDPOINT}
//         columns={exportColumns}
//         exportPageSize={4000}
//         sheetName={({ isAr }) => (isAr ? 'متتبع المشتريات' : 'Purchase Flow')}
//         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
//       />
//     </>
//   );
// };

// export default RPT_PurchaseFlow;


import Select from 'react-select';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';
import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
import ReportPagination from '@Helper/ReportPaged/ReportPagination';
import { Badge, Row, Col, Form } from 'react-bootstrap';

// ✅ استخدام الـ Hooks المطلوبة للفرع والمورد
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

/** =========================
 * INNER REQUEST SHAPE
 * ========================= */
type PurFlowRequestDto = {
  pageIndex?: number;
  pageSize?: number;
  businessGroupId?: string | null;
  purchaseId?: string | null;
  purchaseCodeLike?: string | null;
  purchaseTypeId?: string | null;
  purchaseTypeIds?: string | null;
  purchaseFromDate?: string | null;
  purchaseToDate?: string | null;
  organizationId?: string | null;
  supplierId?: string | null;
  inventoryId?: string | null;
  effect?: number;
  invFromDate?: string | null;
  invToDate?: string | null;
  invBranchId?: string | null;
  invInventoryId?: string | null;
  invTrxTypeId?: string | null;
  invTrxTypeIds?: string | null;
  invCodeLike?: string | null;
  supplierInvoiceNumLike?: string | null;
  invoiceId?: string | null;
  invoiceNumLike?: string | null;
  invoiceType?: string | null;
  invoiceTypes?: string | null;
  invoiceFromDate?: string | null;
  invoiceToDate?: string | null;
  invoicePosted?: boolean | null;
  invoiceCancelled?: boolean | null;
  paymentId?: string | null;
  paymentCodeLike?: string | null;
  paymentStatus?: string | null;
  paymentStatuses?: string | null;
  paymentMethodId?: string | null;
  bankAccountId?: string | null;
  paymentFromDate?: string | null;
  paymentToDate?: string | null;
  onlyWithInvoices?: boolean;
  onlyWithPayments?: boolean;
};

/** =========================
 * RESPONSE SHAPE (Array items)
 * ========================= */
type RowDto = {
  rootId: string;
  nodeId: string;
  parentNodeId: string | null;
  level: number;
  nodeType: string;
  sortKey: string;
  docCode: string | null;
  docName: string | null;
  docDate: string | null;
  organizationId: string | null;
  brancH_NAME: string | null;
  peoplE_NAME: string | null;
  peopleId: string | null;
  inventoryId: string | null;
  amount: number;
  vatAmount: number;
  grossAmount: number;
  effectSign: number;
  effectAmount: number;
  linkSource: string | null;
  matId: string | null;
  matCode: string | null;
  matTypeName: string | null;
  supplierInvoiceNum: string | null;
  postedFlag: boolean | null;
  cancelledFlag: boolean | null;
  invoiceType: string | null;
  paymentStatus: string | null;
  scheduleAmount: number | null;
  scheduleDueDate: string | null;
  paidEffectSum: number | null;
  balanceEffect: number | null;
  paymentMethodId: string | null;
  bankAccountId: string | null;
  appliedAmount: number | null;
  paymentTotalAmount: number | null;
};

const REPORT_KEY = 'RPT_PurFlowPaged';
const ENDPOINT = 'PurchaseOrder/GetPurFlowPagedQuery';

const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

const formatNumber = (num: number | null | undefined, digits: number = 2) => {
  if (num === null || num === undefined) return '0.00';
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(num);
};

const formatDate = (dateString: string | null) => {
  if (!dateString) return '—';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(date);
};

const getOptId = (opt: any): string | null => {
  const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
  return v ? String(v) : null;
};

const isoOrNull = (d: any) => {
  if (!d) return null;
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
  if (d instanceof Date) return d.toISOString();
  return null;
};

const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
  const out: any = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === null || v === undefined || v === '') continue;
    out[k] = v;
  }
  return out;
};

// ======================
// Helpers للمكون
// ======================
const getNodeTypeBadge = (nodeType: string | null, docName: string | null) => {
  if (!nodeType) return <span className='text-muted'>-</span>;
  const t = nodeType.toUpperCase();

  if (t === 'PUR') return <Badge bg="theme" className="bg-opacity-75"><i className="fas fa-shopping-cart me-1"></i> {docName || 'أمر شراء'}</Badge>;
  if (t === 'APINV') return <Badge bg="warning" text="dark" className="bg-opacity-75"><i className="fas fa-file-invoice me-1"></i> {docName || 'فاتورة'}</Badge>;
  if (t === 'PAY') return <Badge bg="success" className="bg-opacity-75"><i className="fas fa-money-bill-wave me-1"></i> {docName || 'سداد'}</Badge>;
  if (t === 'INV') return <Badge bg="info" className="bg-opacity-75"><i className="fas fa-box-open me-1"></i> {docName || 'حركة مخزنية'}</Badge>;

  return <Badge bg="secondary"><i className="fas fa-file-alt me-1"></i> {safe(docName || nodeType)}</Badge>;
};




const PurFlow_Paged = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const isAr = i18n.language !== 'en';

  // ✅ استخدام الـ Hooks كما طلبت بالضبط
  const { OperatingUnitOptions: OptionsBranches, loading: loadingBranches } = useGetOperatingUnitWithPermission();
  const { OptionSuppliers: OptionsSuppliers, loading: loadingSuppliers } = useGetSuppliersList();

  // Filters state
  const [organizationFilter, setOrganizationFilter] = useState<any>(null);
  const [supplierFilter, setSupplierFilter] = useState<any>(null);
  const [purchaseFromDate, setPurchaseFromDate] = useState<any>(null);
  const [purchaseToDate, setPurchaseToDate] = useState<any>(null);
  const [purchaseCodeLike, setPurchaseCodeLike] = useState<string>('');
  
  // Advanced filters (Switches)
  const [onlyWithInvoices, setOnlyWithInvoices] = useState<boolean>(false);
  const [onlyWithPayments, setOnlyWithPayments] = useState<boolean>(false);

  const [showExport, setShowExport] = useState(false);
  
  // Expanded rows state (للشجرة)
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

  // report state
  const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
  const items = (report?.items ?? []) as RowDto[];
  const meta = report?.meta ?? null;
  const loading = report?.loading ?? false;
  const error = report?.error ?? null;

  const exportColumns: ExportColumn<RowDto>[] = [
    { headerAr: 'النوع', headerEn: 'Type', value: r => r.nodeType || '' },
    { headerAr: 'رقم المستند', headerEn: 'Doc Code', value: r => r.docCode || r.docName || '' },
    { headerAr: 'التاريخ', headerEn: 'Date', value: r => formatDate(r.docDate) },
    { headerAr: 'الفرع', headerEn: 'Branch', value: r => r.brancH_NAME || '' },
    { headerAr: 'المورد', headerEn: 'Supplier', value: r => r.peoplE_NAME || '' },
    { headerAr: 'المبلغ الأساسي', headerEn: 'Amount', value: r => r.amount || 0 },
    { headerAr: 'الضريبة', headerEn: 'VAT', value: r => r.vatAmount || 0 },
    { headerAr: 'الإجمالي', headerEn: 'Gross Amount', value: r => r.grossAmount || 0 },
    { headerAr: 'الأثر', headerEn: 'Effect', value: r => r.effectAmount || 0 }
  ];

  useEffect(() => {
    const initialRequest: PurFlowRequestDto = {
      pageIndex: 0,
      pageSize: 50
    };

    dispatch(
      initReport({
        reportKey: REPORT_KEY,
        endpoint: ENDPOINT,
        initialRequest
      })
    );

    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  }, [dispatch]);

  const applyFilters = () => {
    const orgId = getOptId(organizationFilter);
    const suppId = getOptId(supplierFilter);

    const prevReq = (((report as any)?.request ?? {}) as PurFlowRequestDto) || {};

    const nextReq: PurFlowRequestDto = {
      ...prevReq,
      pageIndex: 0,
      pageSize: prevReq.pageSize ?? 50,
      organizationId: orgId,
      supplierId: suppId,
      purchaseFromDate: isoOrNull(purchaseFromDate),
      purchaseToDate: isoOrNull(purchaseToDate),
      purchaseCodeLike: purchaseCodeLike || null,
      onlyWithInvoices: onlyWithInvoices || undefined,
      onlyWithPayments: onlyWithPayments || undefined
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
    
    // عند تطبيق فلاتر جديدة نقوم بطي جميع الصفوف
    setExpandedRows(new Set());
  };

  const clearFilters = () => {
    setOrganizationFilter(null);
    setSupplierFilter(null);
    setPurchaseFromDate(null);
    setPurchaseToDate(null);
    setPurchaseCodeLike('');
    setOnlyWithInvoices(false);
    setOnlyWithPayments(false);

    const resetReq: PurFlowRequestDto = {
      pageIndex: 0,
      pageSize: 50
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
    setExpandedRows(new Set());
  };

  // ======================
  // Tree Logic
  // ======================
  const purchaseOrders = useMemo(() => {
    // جلب الجذور (المستوى 0) وترتيبهم
    const rootItems = items.filter(item => item.level === 0 || item.parentNodeId === null);
    return rootItems.sort((a, b) => a.sortKey.localeCompare(b.sortKey));
  }, [items]);

  const getChildNodes = (nodeId: string): RowDto[] => {
    return items.filter(item => item.parentNodeId === nodeId).sort((a, b) => a.sortKey.localeCompare(b.sortKey));
  };

  const toggleRow = (rowId: string): void => {
    const newExpandedRows = new Set(expandedRows);
    if (newExpandedRows.has(rowId)) {
      newExpandedRows.delete(rowId);
    } else {
      newExpandedRows.add(rowId);
    }
    setExpandedRows(newExpandedRows);
  };

  // ======================
  // Recursive Render Function (الشجرة)
  // ======================
  const renderPurchaseRow = (item: RowDto, level: number = 0, isChild: boolean = false): any => {
    const children = getChildNodes(item.nodeId);
    const hasChildren = children.length > 0;
    const isExpanded = expandedRows.has(item.nodeId);
    const isRoot = item.level === 0;

    return (
      <React.Fragment key={item.nodeId}>
        {/* Main row */}
        <tr className={`align-middle ${isRoot ? 'bg-secondary bg-opacity-25  fw-bold' : ''}`}>
          <td>
            <div className='d-flex align-items-center'>
              {/* Indentation (المسافة البادئة للشجرة) */}
              <div style={{ [isAr ? 'marginLeft' : 'marginRight']: `${level * 25}px` }}></div>

              {/* Expand/Collapse button */}
              {hasChildren ? (
                <button
                  type='button'
                  className='btn btn-sm btn-outline-secondary bg-opacity-25 me-2 p-0 d-flex justify-content-center align-items-center bg-white'
                  onClick={() => toggleRow(item.nodeId)}
                  style={{ width: '22px', height: '22px', borderRadius: '4px' }}
                >
                  <i className={`fas fa-${isExpanded ? 'minus' : 'plus'} fa-xs`}></i>
                </button>
              ) : (
                <span className='me-2' style={{ width: '22px' }}>
                  {!isRoot && <i className="fas fa-level-down-alt fa-rotate-90 text-muted opacity-25 ms-1"></i>}
                </span>
              )}

              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center gap-2 flex-wrap'>
                  <span className={`${isRoot ? 'text-theme' : 'text-dark'}`}>
                    {safe(item.docCode || item.supplierInvoiceNum || item.invoiceType)}
                  </span>
                  {getNodeTypeBadge(item.nodeType, item.docName)}
                  
                  {item.cancelledFlag === true && (
                    <Badge bg="danger" className="bg-opacity-10 text-danger border border-danger">
                      <i className='fas fa-ban me-1'></i> ملغي
                    </Badge>
                  )}
                </div>

            
              </div>
            </div>
          </td>

          <td>
            <div className='fw-medium'>{item.docDate ? item.docDate.split('T')[0] : '—'}</div>
            {item.scheduleDueDate && (
              <small className='text-muted d-block mt-1'>
                <i className='fas fa-calendar-check me-1'></i>
                {item.scheduleDueDate.split('T')[0]}
              </small>
            )}
          </td>

          <td>
            <div className='d-flex flex-column'>
              <strong className={isChild ? 'text-muted fw-medium' : ''}>{safe(item.peoplE_NAME)}</strong>
              {isRoot && <small className="text-muted mt-1"><i className="fas fa-building fa-xs me-1"></i> {safe(item.brancH_NAME)}</small>}
            </div>
          </td>

          <td className='text-end'>
            <div className='fw-bold text-dark'>{formatNumber(item.amount)}</div>
            {item.vatAmount > 0 && <small className="text-muted d-block">ضريبة: {formatNumber(item.vatAmount)}</small>}
          </td>

          <td className='text-center'>
            {item.nodeType === 'APINV' && item.balanceEffect !== null && (
              <div>
                <div className={`fw-bold ${item.balanceEffect > 0 ? 'text-danger' : 'text-success'}`}>
                  {formatNumber(Math.abs(item.balanceEffect))}
                </div>
                {item.paidEffectSum !== null && item.paidEffectSum !== 0 && (
                  <small className='text-muted d-block'>
                    {isAr ? 'مدفوع' : 'Paid'}: {formatNumber(Math.abs(item.paidEffectSum))}
                  </small>
                )}
              </div>
            )}
            
            {item.nodeType === 'PAY' && (
              <div>
                <div className='fw-bold text-success'>{formatNumber(item.appliedAmount || item.amount || 0)}</div>
                {item.paymentStatus && <small className='text-muted d-block'>{item.paymentStatus}</small>}
              </div>
            )}

            {isRoot && (
              <div className={`fw-bold ${item.effectSign < 0 ? 'text-danger' : 'text-success'}`}>
                 {formatNumber(item.grossAmount)}
              </div>
            )}
          </td>

          <td className='text-center'>
            <div className='d-flex flex-column align-items-center gap-1'>
              {item.postedFlag !== null && (
                item.postedFlag ? (
                  <Badge bg="success" className="bg-opacity-10 text-success border border-success px-2 py-1">
                    <i className='fas fa-check-circle me-1'></i> مُرحل
                  </Badge>
                ) : (
                  <Badge bg="warning" className="bg-opacity-10 text-warning border border-warning px-2 py-1">
                    <i className='fas fa-clock me-1'></i> معلق
                  </Badge>
                )
              )}
              {item.postedFlag === null && !item.cancelledFlag && <span className="text-muted">-</span>}
            </div>
          </td>
        </tr>

        {/* Render children if expanded */}
        {hasChildren && isExpanded && children.map(child => renderPurchaseRow(child, level + 1, true))}
      </React.Fragment>
    );
  };

  return (
    <>
      <CardHeader className='mb-3'>
        <div className='d-flex justify-content-between align-items-center mb-3'>
          <h6 className='mb-0 fw-bold'><i className="fas fa-project-diagram text-theme me-2"></i>معايير البحث لدورة المشتريات</h6>
        </div>
        
        <Row className='g-2 align-items-center mb-2'>
          {/* ✅ الفرع المربوط بالـ Hook الجديد */}
          <Col lg={3}>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-building text-theme'></i>
              </span>
              <Select
                isLoading={loadingBranches}
                value={organizationFilter}
                onChange={setOrganizationFilter}
                options={OptionsBranches}
                placeholder={isAr ? 'الفرع / المنظمة' : 'Organization'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </Col>

          {/* ✅ المورد المربوط بالـ Hook الجديد */}
          <Col lg={3}>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-user-tie text-info'></i>
              </span>
              <Select
                isLoading={loadingSuppliers}
                value={supplierFilter}
                onChange={setSupplierFilter}
                options={OptionsSuppliers}
                placeholder={isAr ? 'المورد' : 'Supplier'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </Col>

          {/* من تاريخ الطلب */}
          <Col lg={3}>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={purchaseFromDate || ''}
                onChange={e => setPurchaseFromDate(e.target.value)}
                // placeholder={isAr ? 'من تاريخ الطلب' : 'PUR From Date'}
              />
            </div>
          </Col>

          {/* إلى تاريخ الطلب */}
          <Col lg={3}>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={purchaseToDate || ''}
                onChange={e => setPurchaseToDate(e.target.value)}
                min={purchaseFromDate || undefined}
                // placeholder={isAr ? 'إلى تاريخ الطلب' : 'PUR To Date'}
              />
            </div>
          </Col>
        </Row>

        <Row className='g-2 align-items-center'>
          {/* رقم الطلب */}
          <Col lg={3}>
            <div className='input-group'>
              <span className='input-group-text fw-bold'><i className="fas fa-search"></i></span>
              <input
                type='text'
                className='form-control'
                value={purchaseCodeLike}
                onChange={e => setPurchaseCodeLike(e.target.value)}
                placeholder={isAr ? 'بحث برقم أمر الشراء' : 'PUR Code Like'}
              />
            </div>
          </Col>

          {/* فلاتر إضافية */}
          {/* <Col lg={4} className="d-flex gap-3">
            <Form.Check 
              type="switch"
              id="withInvoicesSwitch"
              label={<span className="fw-bold small">{isAr ? 'لها فواتير فقط' : 'Only w/ Invoices'}</span>}
              checked={onlyWithInvoices}
              onChange={e => setOnlyWithInvoices(e.target.checked)}
              className="pt-2"
            />
            <Form.Check 
              type="switch"
              id="withPaymentsSwitch"
              label={<span className="fw-bold small">{isAr ? 'لها مدفوعات فقط' : 'Only w/ Payments'}</span>}
              checked={onlyWithPayments}
              onChange={e => setOnlyWithPayments(e.target.checked)}
              className="pt-2"
            />
          </Col> */}

          {/* Buttons */}
          <Col lg={9} className='text-end'>
            <button
              className='btn btn-outline-secondary me-2'
              type='button'
              onClick={clearFilters}
              title={t('ClearFilters')}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>
            <button
              className='btn btn-theme me-2 px-3'
              type='button'
              onClick={applyFilters}
              title={t('ApplyFilters')}
            >
              <i className='fas fa-filter fa-fw'></i>
               {/* {isAr ? 'تطبيق الفلاتر' : 'Apply'} */}
            </button>

            <button
              className='btn btn-outline-success'
              type='button'
              onClick={() => setShowExport(true)}
              title={t('Export')}
              disabled={loading || items.length === 0}
            >
              <i className='fas fa-file-excel fa-fw'></i>
            </button>
          </Col>
        </Row>
      </CardHeader>

      <Card className='mb-4 shadow-sm border-0'>
        <Loading loading={loading} error={error}>
          <div className='table-responsive rounded border' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table className='table table-hover mb-0'>
              <thead className='bg-theme bg-opacity-301' style={{ position: 'sticky', top: 0, zIndex: 10, borderBottom: '2px solid #dee2e6' }}>
                <tr>
                  <th className='py-3 text-muted' style={{ minWidth: '350px' }}>{isAr ? 'المستند / المرجع' : 'Document / Ref'}</th>
                  <th className='py-3 text-muted' style={{ minWidth: '150px' }}>{t('Date')}</th>
                  <th className='py-3 text-muted' style={{ minWidth: '200px' }}>{isAr ? 'المورد / الفرع' : 'Supplier / Branch'}</th>
                  <th className='py-3 text-muted text-end' style={{ minWidth: '130px' }}>{isAr ? 'المبلغ' : 'Amount'}</th>
                  <th className='py-3 text-muted text-center' style={{ minWidth: '130px' }}>{isAr ? 'الرصيد / الصافي' : 'Balance / Gross'}</th>
                  <th className='py-3 text-muted text-center' style={{ minWidth: '120px' }}>{isAr ? 'الحالة' : 'Status'}</th>
                </tr>
              </thead>

              <tbody>
                {!loading && purchaseOrders.length > 0 ? (
                  purchaseOrders.map((item) => renderPurchaseRow(item))
                ) : !loading ? (
                  <tr>
                    <td colSpan={6} className='text-center py-5'>
                      <div className='text-muted'>
                        <div className="bg-secondary bg-opacity-25 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '80px', height: '80px' }}>
                          <i className='fas fa-project-diagram fa-2x opacity-50'></i>
                        </div>
                        <h6>{t('NoData')}</h6>
                        <small>{t('TryChangingFilters')}</small>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
            <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />

            {!loading && items.length > 0 && (
              <div className='text-muted small'>
                <i className='fas fa-info-circle me-1'></i>
                {isAr ? 'عرض' : 'Showing'} {items.length} {isAr ? 'من' : 'of'} {meta?.totalRows || 0}{' '}
                {isAr ? 'سجل' : 'records'}
              </div>
            )}
          </div>
        </CardFooter>
      </Card>

      <ReportExportExcelModal
        show={showExport}
        onHide={() => setShowExport(false)}
        reportKey={REPORT_KEY}
        endpoint={ENDPOINT}
        columns={exportColumns}
        exportPageSize={4000}
        sheetName={({ isAr }) => (isAr ? 'دورة المشتريات' : 'Purchase Flow')}
        fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
      />
    </>
  );
};

export default PurFlow_Paged;